import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';
import { useCallback } from 'react';
import moment, { Moment } from 'moment';
import { DateCantBeInThePastRule } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Workflow/Rules/SplitTest/DateCantBeInThePastRule';
import { useTranslation } from 'react-i18next';
import { useWorkflowForm } from '../../../CampaignWorkflowTab/contexts/CampaignWorkflowFormContext';
import { useCampaignSchedulingSelector } from '../../../CampaignWorkflowTab/state/CampaignSettings/selectors/useCampaignSchedulingSelector';

export const endDateFormKey = 'campaign-schedule-end';

const validate = (t, endDate: Date) => {
  if (DateCantBeInThePastRule({ date: endDate }).result === 'fail') {
    return {
      passed: false,
      validationMessage: t('onsite.editor.workflow.scheduling.inlineValidationMessages.endDateInThePast'),
    };
  }

  return {
    passed: true,
    validationMessage: undefined,
  };
};

export const useEndDate = () => {
  const { t } = useTranslation('campaigns');
  const { actions, state } = useWorkflowForm();
  const { dispatch } = useCampaignEditorContext();

  const onFocusChange = useCallback(
    ({ focused }) => {
      actions.setTouched(endDateFormKey, true);
      actions.setFocused(endDateFormKey, focused);
    },
    [actions],
  );

  const { startDate, endDate } = useCampaignSchedulingSelector() ?? {};
  const onDateChange = useCallback(
    (endDate: Moment) => dispatch({ type: 'SET_CAMPAIGN_END_DATE', payload: { endDate: endDate?.toDate() } }),
    [dispatch],
  );

  const validation = validate(t, endDate);
  const minDate = moment(startDate ?? new Date());

  return {
    endDate: endDate ? moment(endDate) : undefined,
    onDateChange,
    onFocusChange,
    focused: state.focused[endDateFormKey],
    minDate,
    validation,
  };
};
